module.exports = __webpack_public_path__ + "static/media/DCI.b3dba6d0.pdf";